import {
   EDITAR_JUSTIFICATIVA,
   INCLUIR_JUSTIFICATIVA,
   OBTER_DESCRICAO,
   OBTER_DESCRICAO_DETALHES,
   OBTER_GRUPO_USUARIO,
   OBTER_OCORRENCIA
} from './mutations-types'

export default {
   [OBTER_OCORRENCIA](state, payload) {
      if (payload) {
         state.items_ocorrencia = payload.items
         state.paginaAtual_ocorrencia = payload.paginaAtual
         state.totalDePaginas_ocorrencia = payload.totalDePaginas
         state.registrosPorPagina_ocorrencia = payload.registrosPorPagina
         state.totalDeRegistros_ocorrencia = payload.totalDeRegistros
         state.possuiPaginaAnterior_ocorrencia = payload.possuiPaginaAnterior
         state.possuiProximaPagina_ocorrencia = payload.possuiProximaPagina
         state.codigo_ocorrencia = payload.codigo
         state.sucesso_ocorrencia = payload.sucesso
         state.mensagens_ocorrencia = payload.mensagens
      } else {
         state.items_ocorrencia = null
      }
   },

   [OBTER_GRUPO_USUARIO](state, payload) {
      if (payload) {
         state.items_grupo_usuario = payload.items
         state.paginaAtual_grupo_usuario = payload.paginaAtual
         state.totalDePaginas_grupo_usuario = payload.totalDePaginas
         state.registrosPorPagina_grupo_usuario = payload.registrosPorPagina
         state.totalDeRegistros_grupo_usuario = payload.totalDeRegistros
         state.possuiPaginaAnterior_grupo_usuario = payload.possuiPaginaAnterior
         state.possuiProximaPagina_grupo_usuario = payload.possuiProximaPagina
         state.codigo_grupo_usuario = payload.codigo
         state.sucesso_grupo_usuario = payload.sucesso
         state.mensagens_grupo_usuario = payload.mensagens
      } else {
         state.items_grupo_usuario = null
      }
   },

   [OBTER_DESCRICAO](state, payload) {
      if (payload) {
         state.items_descricao = payload.items
         state.paginaAtual_descricao = payload.paginaAtual
         state.totalDePaginas_descricao = payload.totalDePaginas
         state.registrosPorPagina_descricao = payload.registrosPorPagina
         state.totalDeRegistros_descricao = payload.totalDeRegistros
         state.possuiPaginaAnterior_descricao = payload.possuiPaginaAnterior
         state.possuiProximaPagina_descricao = payload.possuiProximaPagina
         state.codigo_descricao = payload.codigo
         state.sucesso_descricao = payload.sucesso
         state.mensagens_descricao = payload.mensagens
      } else {
         state.items_descricao = null
      }
   },

   [OBTER_DESCRICAO_DETALHES](state, payload) {
      if (payload) {
         state.items_descricao_detalhes = payload
      }
   },

   [INCLUIR_JUSTIFICATIVA](state, payload) {
      state.justificativa = payload
   },

   [EDITAR_JUSTIFICATIVA](state, payload) {
      state.justificativa_editar = payload
   }
}
